const ITALIC_HEADER_PATTERN = /\*\[(.*?)\]\*/g;

function applyItalicHeaderMarkup(root = document) {
    root.querySelectorAll('h2, h3').forEach((header) => {
        if (header.dataset.italicsProcessed === 'true') return;

        const html = header.innerHTML;
        if (!html.includes('*[')) return;

        header.innerHTML = html.replace(
            ITALIC_HEADER_PATTERN,
            '<span class="italics-header-font">$1</span>'
        );
        header.dataset.italicsProcessed = 'true';
    });
}

function revealScrollTriggers(container) {
    if (!container) return;

    container.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.remove('scroll-trigger--offscreen');
    });
}

function initSlideshowScrollTriggers() {
    document.querySelectorAll('slideshow-component carousel-component').forEach((carousel) => {
        if (carousel.dataset.italicsCarouselBound === 'true') return;

        const bind = () => {
            if (!carousel.embla) {
                requestAnimationFrame(bind);
                return;
            }

            carousel.dataset.italicsCarouselBound = 'true';

            const activateSlide = () => {
                const slide = carousel.embla.slideNodes()[carousel.embla.selectedScrollSnap()];
                applyItalicHeaderMarkup(slide);
                revealScrollTriggers(slide);
            };

            activateSlide();
            carousel.embla.on('select', activateSlide);
            carousel.embla.on('reInit', activateSlide);
        };

        bind();
    });
}

function waitForEmbla(carousel, callback, attempts = 60) {
    if (carousel?.embla) {
        callback();
        return;
    }

    if (attempts <= 0) return;

    requestAnimationFrame(() => waitForEmbla(carousel, callback, attempts - 1));
}

function stackRotatedImages(images, activeIndex, length) {
    images.forEach((img, index) => {
        if (index === activeIndex) {
            img.style.zIndex = '0';
        } else if (index > activeIndex) {
            img.style.zIndex = String(activeIndex - index);
        } else {
            img.style.zIndex = String(-length - index + 1);
        }
    });
}

function activateVerticalScrollSlide(imageSlider, index, withRotate) {
    const images = [...imageSlider.querySelectorAll('[data-image-slider-image]')];
    const captions = [...imageSlider.querySelectorAll('[data-image-slider-caption]')];

    if (withRotate) {
        images.forEach((img, imageIndex) => {
            if (imageIndex === index) {
                img.setAttribute('visible', '');
                img.removeAttribute('prev');
                img.removeAttribute('next');
            } else if (imageIndex < index) {
                img.setAttribute('prev', '');
                img.removeAttribute('visible');
                img.removeAttribute('next');
            } else {
                img.setAttribute('next', '');
                img.removeAttribute('visible');
                img.removeAttribute('prev');
            }
        });
    } else {
        images.forEach((img, imageIndex) => {
            if (imageIndex === index) img.setAttribute('visible', '');
            else img.removeAttribute('visible');
        });
    }

    captions.forEach((caption, captionIndex) => {
        if (captionIndex === index) caption.setAttribute('visible', '');
        else caption.removeAttribute('visible');
    });
}

function activateRotateSlide(imageSlider, index) {
    const images = [...imageSlider.querySelectorAll('[data-image-slider-image]')];
    const captions = [...imageSlider.querySelectorAll('[data-image-slider-caption]')];
    const length = images.length - 1;

    captions.forEach((caption, captionIndex) => {
        if (captionIndex === index) caption.setAttribute('visible', '');
        else caption.removeAttribute('visible');
    });

    images.forEach((img, imageIndex) => {
        if (imageIndex === index) img.setAttribute('visible', '');
        else img.removeAttribute('visible');
    });

    stackRotatedImages(images, index, length);

    const dots = imageSlider.querySelector('carousel-dynamic-dots');
    if (dots?.updateDots) dots.updateDots(index);
}

function activateImageScrollerSlide(imageSlider, index) {
    if (!imageSlider || Number.isNaN(index) || index < 0) return;

    const withVerticalScroll = imageSlider.hasAttribute('with-vertical-scroll');
    const withVerticalScrollImage = imageSlider.hasAttribute('with-vertical-scroll-image');
    const withRotate = imageSlider.hasAttribute('with-rotate-images');
    const carousel = imageSlider.querySelector('carousel-component');

    if (withVerticalScroll || withVerticalScrollImage) {
        activateVerticalScrollSlide(imageSlider, index, withRotate);
        return;
    }

    if (carousel) {
        waitForEmbla(carousel, () => {
            if (withRotate) {
                activateRotateSlide(imageSlider, index);
                return;
            }

            carousel.embla.scrollTo(index);
        });
        return;
    }

    if (withRotate) {
        activateRotateSlide(imageSlider, index);
    }
}

function findVisibleImageScrollerAnchor(anchorId) {
    const anchors = document.querySelectorAll(
        `[data-image-scroller-anchor-id="${CSS.escape(anchorId)}"]`
    );

    for (const anchor of anchors) {
        const sliderWrapper = anchor.closest('.image-slider--desktop, .image-slider--mobile');
        if (sliderWrapper && getComputedStyle(sliderWrapper).display !== 'none') {
            return anchor;
        }
    }

    return null;
}

function navigateToImageScrollerAnchor(anchorId) {
    if (!anchorId) return false;

    const anchor = findVisibleImageScrollerAnchor(anchorId);
    if (!anchor) return false;

    const imageSlider = anchor.closest('image-slider');
    if (!imageSlider) return false;

    const index = Number.parseInt(anchor.getAttribute('data-image-scroller-slide-index'), 10);
    if (Number.isNaN(index)) return false;

    document
        .querySelectorAll('[data-image-scroller-anchor-id]')
        .forEach((element) => element.removeAttribute('id'));

    anchor.id = anchorId;
    activateImageScrollerSlide(imageSlider, index);

    requestAnimationFrame(() => {
        anchor.scrollIntoView({ behavior: 'auto', block: 'start' });
    });

    return true;
}

function handleImageScrollerHash() {
    const anchorId = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    if (!anchorId) return;

    navigateToImageScrollerAnchor(anchorId);
}

function initImageScrollerHashNavigation() {
    handleImageScrollerHash();
    requestAnimationFrame(handleImageScrollerHash);
    window.setTimeout(handleImageScrollerHash, 150);
    window.setTimeout(handleImageScrollerHash, 500);
}

function measureTruncatePanel(panel) {
    const wasHidden = panel.hidden;

    panel.hidden = false;
    panel.style.visibility = 'hidden';
    panel.style.position = 'absolute';
    panel.style.insetInline = '0';
    panel.style.insetBlockStart = '0';

    const height = panel.offsetHeight;

    panel.style.visibility = '';
    panel.style.position = '';
    panel.style.insetInline = '';
    panel.style.insetBlockStart = '';
    panel.hidden = wasHidden;

    return height;
}

function initProductDescriptionTruncate(root = document) {
    root.querySelectorAll('[data-product-description-truncate]').forEach((container) => {
        if (container.dataset.truncateInitialized === 'true') return;

        const viewport = container.querySelector('[data-truncate-viewport]');
        const toggle = container.querySelector('[data-truncate-toggle]');
        const shortEl = container.querySelector('[data-truncate-short]');
        const fullEl = container.querySelector('[data-truncate-full]');
        const moreLabel = container.querySelector('[data-truncate-more]');
        const lessLabel = container.querySelector('[data-truncate-less]');

        if (!viewport || !toggle || !shortEl || !fullEl) return;

        container.dataset.truncateInitialized = 'true';

        toggle.addEventListener('click', () => {
            if (container.classList.contains('is-transitioning')) return;

            const willExpand = !container.classList.contains('is-expanded');
            const fromHeight = willExpand ? shortEl.offsetHeight : fullEl.offsetHeight;
            const toHeight = measureTruncatePanel(willExpand ? fullEl : shortEl);

            container.classList.add('is-transitioning');
            viewport.style.height = `${fromHeight}px`;

            if (willExpand) {
                shortEl.hidden = true;
                fullEl.hidden = false;
            }

            requestAnimationFrame(() => {
                viewport.style.height = `${toHeight}px`;
            });

            const onTransitionEnd = (event) => {
                if (event.target !== viewport || event.propertyName !== 'height') return;

                viewport.removeEventListener('transitionend', onTransitionEnd);
                container.classList.remove('is-transitioning');
                container.classList.toggle('is-expanded', willExpand);

                if (!willExpand) {
                    fullEl.hidden = true;
                    shortEl.hidden = false;
                }

                viewport.style.height = '';

                toggle.setAttribute('aria-expanded', String(willExpand));
                shortEl.setAttribute('aria-hidden', String(willExpand));
                fullEl.setAttribute('aria-hidden', String(!willExpand));

                if (moreLabel) moreLabel.hidden = willExpand;
                if (lessLabel) lessLabel.hidden = !willExpand;
            };

            viewport.addEventListener('transitionend', onTransitionEnd);

            window.setTimeout(() => {
                if (container.classList.contains('is-transitioning')) {
                    onTransitionEnd({ target: viewport, propertyName: 'height' });
                }
            }, 400);
        });
    });
}

function initCustomScripts() {
    function isExternalLink(url) {
        const tempAnchor = url;
        if (tempAnchor.hostname !== window.location.hostname) {
            url.setAttribute('target', '_blank');
        }
    }

    document.querySelectorAll('a').forEach((link) => {
        isExternalLink(link);
    });

    applyItalicHeaderMarkup();
    initSlideshowScrollTriggers();
    initImageScrollerHashNavigation();
    initProductDescriptionTruncate();

    // Run again after scroll-animation setup and web fonts load
    requestAnimationFrame(() => {
        applyItalicHeaderMarkup();
        initSlideshowScrollTriggers();
        initImageScrollerHashNavigation();
    });

    if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
            applyItalicHeaderMarkup();
        });
    }
}

document.addEventListener('DOMContentLoaded', initCustomScripts);
document.addEventListener('shopify:section:load', (event) => {
    applyItalicHeaderMarkup(event.target);
    initSlideshowScrollTriggers();
    initProductDescriptionTruncate(event.target);

    if (event.target.querySelector('[data-image-scroller-anchor-id]')) {
        initImageScrollerHashNavigation();
    }
});

window.addEventListener('hashchange', handleImageScrollerHash);
